module.exports = __webpack_public_path__ + "img/logo3.e04c129d.png";